// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Event/components/AddEvent.css
// module id = 944
// module chunks = 0